module.exports = __webpack_public_path__ + "img/full7-min.2daa2fc6.png";